/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import _ from 'lodash';
import clsx from 'clsx';

import IconRadiobuttonChecked from '../icons/svgr/IconRadiobuttonChecked';
import IconRadiobuttonUnchecked from '../icons/svgr/IconRadiobuttonUnchecked';
import InputContainer from '../forms/InputContainer';
import RadioButton from './RadioButton';

export interface RadioButtonOption<T> {
  label: string | React.ReactNode;
  icon?: any;
  subtext?: string;
  key: React.Key;
  value?: T;
  disabled?: boolean;
  helperComponent?: React.ReactNode;
  inlineHelperComponent?: React.ReactNode;
}

interface Props<T> {
  'data-testid'?: string;
  disabled?: boolean;
  field: ReduxFormField<T>;
  options: RadioButtonOption<T>[];
  modifierClassName?: string;
  onChange?(value: any): void;
}

/**
 * @deprecated
 * Please see the inputs in the ui folder of your project
 */
export default class RadioButtons<T> extends React.PureComponent<Props<T>> {
  static defaultProps: Partial<Props<any>> = {
    modifierClassName: 'RadioButtons--default',
  };

  render() {
    const { disabled, field, modifierClassName, options } = this.props;
    const className = clsx('RadioButtons', modifierClassName);

    return (
      <InputContainer className={className} data-testid={this.props['data-testid']}>
        {_.map(options, (option) => {
          const isChecked = field.value === option.value;

          let isDisabled = option.disabled;

          if (disabled) {
            isDisabled = true;
          }

          const className = clsx('RadioButton', {
            'is-checked': isChecked,
            'is-disabled': isDisabled,
          });
          const iconClassName = clsx('RadioButton-icon', option.icon);
          const dataTestIdValue = this.props.field.name + '_' + option.value;

          return [
            <label key={option.key} htmlFor={_.toString(option.key)} className={className}>
              <RadioButton
                disabled={isDisabled}
                field={this.props.field}
                id={_.toString(option.key)}
                value={option.value}
                checked={isChecked}
                onChange={this.props.onChange}
              />

              <div
                className="RadioButton-indicator"
                role="radio"
                aria-checked={isChecked}
                data-testid={dataTestIdValue}
              >
                {isChecked && <IconRadiobuttonChecked className={iconClassName} />}
                {!isChecked && <IconRadiobuttonUnchecked className={iconClassName} />}
                <span className="RadioButton-label">{option.label}</span>
              </div>
              {option.inlineHelperComponent && (
                <div
                  key={`${option.key}-inlineHelperComponent`}
                  className="RadioButton-inlineHelperComponent"
                >
                  {option.inlineHelperComponent}
                </div>
              )}
            </label>,
            option.subtext && (
              <div key={`${option.key}-subtext`} className="RadioButton-subtext">
                {option.subtext}
              </div>
            ),
            option.helperComponent && (
              <div key={`${option.key}-helperComponent`} className="RadioButton-helperComponent">
                {option.helperComponent}
              </div>
            ),
          ];
        })}
      </InputContainer>
    );
  }
}
